module.exports = __webpack_public_path__ + "media/images/placeholders/angehoerige-35183ecdbfac4d2a8f5aa23124570251.jpg";